/**
 * chapter-progress.tsx — a chapter's progress in words, both its measures
 * labelled: "1 of 6 activities · 8% of XP". The campaign's overview card, its
 * chapter rows and the chapter's own hero each say it this way, beside a bar
 * that shows the XP, as every progress bar in the student area does; each lays
 * the words out in the room it has, and the two measures wrap apart, never
 * mid-measure.
 */

import { useTranslation } from 'react-i18next';
import { chapterProgress } from '../../../api/student/campaigns/gating';
import type { StudentCampaignChapter } from '../../../api/student/campaigns/types';
import styles from './chapter-progress.module.css';

/** A chapter's activities done of its total and its share of XP earned, each labelled. */
export function ChapterProgressWords({ chapter }: { chapter: StudentCampaignChapter }) {
  const { t } = useTranslation();
  const { done, total, xpPct } = chapterProgress(chapter);
  return (
    <span className={styles.clip}>
      <span className={styles.words}>
        <span>{t('student.campaign.chapterActivities', { done, count: total })}</span>
        <span>{t('student.campaign.chapterXpShare', { pct: xpPct })}</span>
      </span>
    </span>
  );
}
